import { skipToken } from "@tanstack/react-query";
import { isObject } from "@trpc/server/unstable-core-do-not-import";

//#region src/internals/getQueryKey.ts
/**
* To allow easy interactions with groups of related queries, such as
* invalidating all queries of a router, we use an array as the path when
* storing in tanstack query.
**/
function getQueryKeyInternal(path, input, type) {
	const splitPath = path.flatMap((part) => part.split("."));
	if (!input && (!type || type === "any")) return splitPath.length ? [splitPath] : [];
	if (type === "infinite" && isObject(input) && ("direction" in input || "cursor" in input)) {
		const { cursor: _, direction: __,...inputWithoutCursorAndDirection } = input;
		return [splitPath, {
			input: inputWithoutCursorAndDirection,
			type: "infinite"
		}];
	}
	return [splitPath, {
		...typeof input !== "undefined" && input !== skipToken && { input },
		...type && type !== "any" && { type }
	}];
}
function getMutationKeyInternal(path) {
	return getQueryKeyInternal(path, void 0, "any");
}
/**
* Method to extract the query key for a procedure
* @param procedureOrRouter - procedure or AnyRouter
* @param input - input to procedureOrRouter
* @param type - defaults to `any`
* @see https://trpc.io/docs/v11/getQueryKey
*/
function getQueryKey(procedureOrRouter, ..._params) {
	const [input, type] = _params;
	const path = procedureOrRouter._def().path;
	const queryKey = getQueryKeyInternal(path, input, type ?? "any");
	return queryKey;
}
/**
* Method to extract the mutation key for a procedure
* @param procedure - procedure
* @see https://trpc.io/docs/v11/getQueryKey#mutations
*/
function getMutationKey(procedure) {
	const path = procedure._def().path;
	return getMutationKeyInternal(path);
}

//#endregion
export { getMutationKey, getMutationKeyInternal, getQueryKey, getQueryKeyInternal };
//# sourceMappingURL=getQueryKey-Dekty44G.mjs.map